import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { LoginManager } from '../../core/login-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import getPhotoUrl from '../utils/getPhotoUrl/getPhotoUrl.ts';
import {createRoot} from 'react-dom/client';
import ModalMap from '../utils/ticket/ModalMap.js';

export default function InstanceCompilerTopHook({ data, entity = null, setDataKeyValue }) {

    const [photoGallery , setPhotoGallery] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {

        if (entity !== 'ticket') return;

        disableTicketFieldsForAuthorities({ data, entity, setDataKeyValue });
        setTimeout(() => {
            console.log('disableTicketFieldsForAuthorities');
            disableTicketFieldsForAuthorities({ data, entity, setDataKeyValue });
          }, 1000);
        addLabels({ data, entity, setDataKeyValue });
          
        }, [data]);
        
    useEffect(() => {
        if (entity !== 'ticket') return;
        autocompleteFields({ data, entity, setDataKeyValue });
    },[data.status]);
    
    useEffect(() => {
        if (entity !== 'ticket') return;
        const titleEle = document.querySelector('h3');
        const id = new URLSearchParams(window.location.search).get('id');
        if (titleEle && !titleEle.innerText.includes('#' + id)) {
            const title = titleEle.innerText.split('-');
            titleEle.innerText = title[0] + ' - ' + 'Segnalazione' + '#' + id;   
        }
    },[data.id]);

    // init swiper to show photos
    useEffect( () =>{

        if (entity !== 'ticket') return;

        if( !data?.gallery ) return;

        
        let gallery = [];
        Object.values(data?.gallery).map( (photo) => {
            const entity = photo.file?.entity;
            const hash = photo.file?.hash;
            const ext = photo.file?.extension;
            gallery.push( { 
                'url':getPhotoUrl(entity , hash , ext) ,
                'width' : photo.file?.width ,
                'height': photo.file?.extension
            } );
        })
        
        setPhotoGallery(gallery);

        const refElement = document.querySelector('#ticket_field_gallery .field__deepExternalEntity');

        if(document.querySelector('#photoGallery')){
            document.querySelector('#photoGallery').remove();
        }

        if (refElement) {
            const container = document.createElement('div');
            container.id = "photoGallery";
            refElement.parentNode.insertBefore(container, refElement);
        
            const root = createRoot(container);
            root.render(<InitSwiper gallery={gallery} />);
        }
        

    },[data.gallery]);

    useEffect(() => {

        // show map button

        return 

        if (entity !== 'ticket') return;
        
        if( !data?.longitude && !data?.latitude ) return;

        if( document.querySelector('#showOnMap') ){ 
            document.querySelector('#showOnMap').remove();
        };

        if( document.querySelector('#ModalMapContainer') ){
            document.querySelector('#ModalMapContainer').remove();
        }
        const root = document.querySelector('#root');
        const container = document.createElement('div');
        container.id = "ModalMapContainer";
        root.appendChild(container);
        const rootMap = createRoot(container);
        rootMap.render( <ModalMap data={data} show={showModal} setShow={setShowModal}/> );

        const refElement = document.querySelector('#ticket_field_address');
        if (refElement) {
            const button = document.createElement('a');
            button.className = 'btn btn-primary w-100 mt-2';
            button.innerText = 'Visualizza su mappa';
            button.href = '#';
            button.id = 'showOnMap';
            button.onclick = (event) => {
                event.preventDefault();
                console.log('showOnMap');
                setShowModal(true);
            };
            refElement.appendChild(button);
        }
    },[data]);

    function addLabels({ data, entity, setDataKeyValue }) {
        const location = window.location;

        if( entity !== 'ticket' && !location.pathname.includes("ticket/edit") ) return;

        const refAdminEleClosed = document.querySelector('#ticket_field_adminClosedNotes .form-label');
        const refUserEleClosed = document.querySelector('#ticket_field_userClosedNotes .form-label');
        const refAdminEleInProgress = document.querySelector('#ticket_field_adminInProgressNotes .form-label');
        const refUserEleInProgress = document.querySelector('#ticket_field_userInProgressNotes .form-label');
        if( !refAdminEleClosed.querySelector('span') ){
            refAdminEleClosed.innerHTML += ' <span class="badge bg-warning text-dark">Visibile solo agli amministratori</span>';
        }
        if( !refAdminEleInProgress.querySelector('span') ){
            refAdminEleInProgress.innerHTML += ' <span class="badge bg-warning text-dark">Visibile solo agli amministratori</span>';
        }
        if( !refUserEleClosed.querySelector('span') ){
            refUserEleClosed.innerHTML += ' <span class="badge bg-danger text-light">Visibile all\'utente</span>';
        }
        if( !refUserEleInProgress.querySelector('span') ){
            refUserEleInProgress.innerHTML += ' <span class="badge bg-danger text-light">Visibile all\'utente</span>';
        }
    }

    function autocompleteFields({ data, entity, setDataKeyValue }){
        const location = window.location;

        if( entity !== 'ticket' && !location.pathname.includes("ticket/edit") ) return;
        
        if(data.status?.value === "5_OPEN"){
            document.querySelector('#ticket_field_inProgressDate input')?.setAttribute('disabled' , true);
            document.querySelector('#ticket_field_inProgressDate input')?.classList.add('pointer-events-none' , 'disabled');
            document.querySelector('#ticket_field_closedDate input')?.setAttribute('disabled' , true);
            document.querySelector('#ticket_field_closedDate input')?.classList.add('pointer-events-none' , 'disabled');
            setDataKeyValue('inProgressDate' , '');
            setDataKeyValue('closedDate' , '');
        }

        if(data.status?.value === "10_IN_PROGRESS"){
            document.querySelector('#ticket_field_inProgressDate input')?.removeAttribute('disabled');
            document.querySelector('#ticket_field_inProgressDate input')?.classList.remove('pointer-events-none' , 'disabled');
            document.querySelector('#ticket_field_closedDate input')?.setAttribute('disabled' , true);
            document.querySelector('#ticket_field_closedDate input')?.classList.add('pointer-events-none' , 'disabled');
            console.log(!data.inProgressDate);
            if(!data.inProgressDate){
                const now = new Date();
                const formatted = now.toISOString().split('T')[0];
                setDataKeyValue('inProgressDate' , formatted);
            }
            setDataKeyValue('closedDate' , '');
        }
        if(data.status?.value === "15_CLOSED"){
            document.querySelector('#ticket_field_inProgressDate input')?.removeAttribute('disabled');
            document.querySelector('#ticket_field_inProgressDate input')?.classList.remove('pointer-events-none' , 'disabled');
            document.querySelector('#ticket_field_closedDate input')?.removeAttribute('disabled');
            document.querySelector('#ticket_field_closedDate input')?.classList.remove('pointer-events-none' , 'disabled');
            if(data.inProgressDate === ''){
                const now = new Date();
                const formatted = now.toISOString().split('T')[0];
                setDataKeyValue('inProgressDate' , formatted);
            }
            if(data.closedDate === ''){
                const now = new Date();
                const formatted = now.toISOString().split('T')[0];
                setDataKeyValue('closedDate' , formatted);
            }
        }

        
        console.log(data.status);
        return 
    }

    function disableTicketFieldsForAuthorities({ data, entity , setDataKeyValue }) {

        const location = window.location;
        const userinfo = LoginManager.getUserInfo();
        
        if(parseInt(userinfo.idUserGroup, 10) <= 0) return; // apply only for authorities
        
        console.log('location.pathname');
        console.log(location.pathname);
        if( entity !== 'ticket' && !location.pathname.includes("ticket/edit") ) return;

        const blockedFields = [
            '#ticket_field_idUserGroup' ,
            '#ticket_field_author',
            '#ticket_field_idCategory',
            '#ticket_field_idSubcategory',
            '#ticket_field_coordinates',
            '#ticket_field_locality',
            '#ticket_field_description',
            '#ticket_field_address',
        ];
        console.log( 'step 0' );
        blockedFields.forEach( (id , index) =>{
            if( document.querySelector(id + ' input') ){
                document.querySelector(id + ' input').classList.add('disabled');
                document.querySelector(id + ' input').disabled = true;
            }
            if( document.querySelector(id + ' textarea') ){
                document.querySelector(id + ' textarea').classList.add('disabled');
                document.querySelector(id + ' textarea').disabled = true;
            }
            if( document.querySelector(id + ' button') ){
                document.querySelector(id + ' button').style = 'background-color: var(--bs-gray-500); border-color:var(--bs-gray-500)';
                document.querySelector(id + ' button').classList.add('pe-none');
            }
            if( document.querySelector(id + ' .input-group') ){
                document.querySelector(id + ' .input-group').classList.add('disabled');
                document.querySelector(id + ' .input-group').classList.add('pe-none');
            }
        } );

        document.querySelector('#ticket_field_latitude') && document.querySelector('#ticket_field_latitude').classList.add('d-none');
        document.querySelector('#ticket_field_longitude') && document.querySelector('#ticket_field_longitude').classList.add('d-none');
        document.querySelector('#ticket_field_idUserGroup') && document.querySelector('#ticket_field_idUserGroup').classList.add('d-none');
        document.querySelector('#ticket_field_gallery .field__deepExternalEntity') && document.querySelector('#ticket_field_gallery .field__deepExternalEntity').classList.add('d-none');
    }

    function InitSwiper({gallery}) {
        console.log({gallery});
        if(gallery.length <= 0) return(<div></div>);

        return (
            <>
            <label class="small form-label">Gallery</label>
                <Swiper
                    modules={[Navigation]}
                    spaceBetween={50}
                    slidesPerView={3}
                    breakpoints={
                        {
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 40
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 30
                            },
                            640: {
                                slidesPerView: 1,
                                spaceBetween: 20
                            }
                        }
                    }
                    loop
                    navigation
                    className='mb-4'
                >
                    {
                        gallery.map( (photo , index) => {
                            return (
                                <SwiperSlide key={index} style={ { backgroundImage : `url(${ getPhotoUrl() })`, backgroundSize:"cover" , backgroundPosition:"center center"}}>
                                    <a href={`${photo.url}`} target='_blank'>
                                        <img src={`${photo.url}`} alt={`segnalazione foto ${index}` } width='100%' height={`${photo.width/photo.height}%`} />
                                    </a>
                                </SwiperSlide>
                            )
                        })
                    }

                </Swiper>
            </>
          );
    }

    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch(entity) {
                        case 'simple': return (
                            <span>Test</span>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};